import moment from "moment";
import { useEffect, useRef, useState } from "react";

const Timer = ({ type, timerSeconds, setTimerSeconds, timerActive, setTimerActive, stringFormat }) => {
  const [timerString, setTimerString] = useState('');
  const workerRef = useRef(new Worker(new URL('./backgroundWorker.js', import.meta.url)));

  const updateTimerString = () => {
    setTimerString(moment.utc(timerSeconds * 1000).format(stringFormat));
  };

  useEffect(() => {
    if (timerActive) {
      workerRef.current.postMessage({ command: 'start', params: { type: type.toLowerCase(), startSeconds: timerSeconds } });
    } else {
      workerRef.current.postMessage({ command: 'stop'});
    }
  }, [timerActive]);

  useEffect(() => {
    updateTimerString();
  }, [timerSeconds]);

  useEffect(() => {
    workerRef.current.onmessage = (event) => {
      setTimerSeconds(event.data);
      
      if (type.toLowerCase() === 'countdown' && event.data === 0) {
        setTimerActive(false);
      }
    };

    return () => {
      workerRef.current.terminate();
    }
  }, []);

  return (
    <span>{timerString}</span>
  )
}

export default Timer;